/**
 * useChangeVideo Hook
 * Custom hook for changing a profile video (delete existing and upload new)
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import apiClient from "@/lib/api-client"

async function changeVideo(userId: string, file: File) {
  const formData = new FormData()
  formData.append("file", file)

  const { data } = await apiClient.put(`api/profiles/${userId}/videos`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })

  return data.data.video
}

export function useChangeVideo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, file }: { userId: string; file: File }) => changeVideo(userId, file),
    onSuccess: async (_data, variables) => {
      // Invalidate video query to trigger refetch
      queryClient.invalidateQueries({ queryKey: ["video", variables.userId] })
    },
  })
}
